import { render, staticRenderFns } from "./ItemContaFuturoEdit.vue?vue&type=template&id=b0d51978&scoped=true&"
import script from "./ItemContaFuturoEdit.vue?vue&type=script&lang=js&"
export * from "./ItemContaFuturoEdit.vue?vue&type=script&lang=js&"
import style0 from "./ItemContaFuturoEdit.vue?vue&type=style&index=0&id=b0d51978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d51978",
  null
  
)

export default component.exports